namespace Portico.Directives {

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import ps = Portico.Services;
	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	export interface ITcSurveyController {
		change: () => void;
		controlClass: string;
		disabled: string;
		groupClass: string;
		inputClass: string;
		key: pme.Account;
		labelClass: string;
		maxlength: string;
		maxlengthMessage: string;
		messageClass: string;
		minlength: string;
		minlengthMessage: string;
		pattern: string;
		patternMessage: string;
		placeholder: string;
		readonly: string;
		required: string;
		requiredMessage: string;
		rows: string;
		section: string;
		type: string;

		onChange: () => void;
	}

	export class TcSurveyController implements ITcSurveyController {
		change: () => void;
		controlClass: string;
		disabled: string;
		groupClass: string;
		inputClass: string;
		key: pme.Account;
		labelClass: string;
		maxlength: string;
		maxlengthMessage: string;
		messageClass: string;
		minlength: string;
		minlengthMessage: string;
		pattern: string;
		patternMessage: string;
		placeholder: string;
		readonly: string;
		required: string;
		requiredMessage: string;
		rows: string;
		section: string;
		type: string;

		onChange() {
			if (this.change) {
				this.change();
			}
		}
	}

	angular.module('app').directive('tcSurvey', [
		'$compile',
		'$state',
		'dataService', (
			$compile: angular.ICompileService,
			$state: angular.ui.IStateService,
			dataService: ps.IDataService
		) => {
			return {
				bindToController: {
					change: '&?',
					controlClass: '@',
					disabled: '@',
					groupClass: '@',
					inputClass: '@',
					key: '=',
					labelClass: '@',
					maxlength: '@',
					maxlengthMessage: '@',
					messageClass: '@',
					minlength: '@',
					minlengthMessage: '@',
					pattern: '@',
					patternMessage: '@',
					placeholder: '@',
					readonly: '@',
					required: '@',
					requiredMessage: '@',
					rows: '@',
					section: '@',
					type: '@'
				},
				controller: <any>TcSurveyController,
				controllerAs: '$survey',
				link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
					const tcSurvey: ITcSurveyController = $ctrl[0];
					let html = '';

					if (dataService.enterprise.intakeLayout) {
						const layoutSection = dataService.enterprise.intakeLayout.getLayoutSection(tcSurvey.section);

						if (layoutSection) {
							const questions = layoutSection.questions;

							if (questions) {
								const type = tcSurvey.type ? tcSurvey.type : 'radio';
								let inputAttrs = `change="$survey.onChange()" `;

								if (tcSurvey.controlClass) {
									inputAttrs += `control-class="${tcSurvey.controlClass}" `;
								}

								if (tcSurvey.disabled) {
									inputAttrs += `disabled="${tcSurvey.disabled}" `;
								}

								if (tcSurvey.groupClass) {
									inputAttrs += `group-class="${tcSurvey.groupClass}" `;
								}

								if (tcSurvey.inputClass) {
									inputAttrs += `input-class="${tcSurvey.inputClass}" `;
								}

								if (tcSurvey.labelClass) {
									inputAttrs += `label-class="${tcSurvey.labelClass}" `;
								}

								if (tcSurvey.maxlength) {
									inputAttrs += `maxlength="${tcSurvey.maxlength}" `;
								}

								if (tcSurvey.maxlengthMessage) {
									inputAttrs += `maxlength-message="${tcSurvey.maxlengthMessage}" `;
								}

								if (tcSurvey.messageClass) {
									inputAttrs += `message-class="${tcSurvey.messageClass}" `;
								}

								if (tcSurvey.minlength) {
									inputAttrs += `minlength="${tcSurvey.minlength}" `;
								}

								if (tcSurvey.minlengthMessage) {
									inputAttrs += `minlength-message="${tcSurvey.minlengthMessage}" `;
								}

								if (tcSurvey.pattern) {
									inputAttrs += `pattern="${tcSurvey.pattern}" `;
								}

								if (tcSurvey.patternMessage) {
									inputAttrs += `pattern-message="${tcSurvey.patternMessage}" `;
								}

								if (tcSurvey.placeholder) {
									inputAttrs += `placeholder="${tcSurvey.placeholder}" `;
								}

								if (tcSurvey.readonly) {
									inputAttrs += `readonly="${tcSurvey.readonly}" `;
								}

								if (tcSurvey.required) {
									inputAttrs += `required="${tcSurvey.required}" `;
								}

								if (tcSurvey.requiredMessage) {
									inputAttrs += `required-message="${tcSurvey.requiredMessage}" `;
								}

								if (tcSurvey.rows) {
									inputAttrs += `rows="${tcSurvey.rows}" `;
								}

								for (let i = 0; i < questions.length; i++) {
									html +=
										`<div class="row flat">
											<div class="col-xs-12">
												<tc-question key="$survey.key" question-id="${questions[i].questionId}" type="${type}" ${inputAttrs} />
											</div>
										</div>`;
								}
							}
						}
					}

					$element.html(html);
					$compile($element.contents() as any)($scope);
				},
				restrict: 'E',
				require: ['tcSurvey'],
				scope: true
			}
		}
	]);
}